import { EmotionUtils, TopEmotion } from '@/utils/emotion-detector';

/**
 * Generates status message for detected emotion with emoji
 */
export function getDetectedEmotionStatus(emotion: TopEmotion): string {
	return `🎭 Detected: ${EmotionUtils.getEmotionEmoji(emotion)} ${emotion}. Is this correct?`;
}

/**
 * Generates status message for confirmed/selected emotion with emoji
 */
export function getConfirmedEmotionStatus(emotion: TopEmotion, action: 'Confirmed' | 'Selected'): string {
	return `🎯 ${action}: ${EmotionUtils.getEmotionEmoji(
		emotion,
	)} ${emotion}. You can change this selection if needed.`;
}

/**
 * Generates error status message
 */
export function getErrorStatus(errorMessage: string): string {
	return `❌ Error: ${errorMessage}`;
}
